import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@hotelise/ui";
import { BaseModalProps } from "interfaces/modals";
import { ColumnDefinition } from "hooks/useColumnPreferences";

interface Props extends BaseModalProps {
	columns: ColumnDefinition[];
	onToggle: (id: string) => void;
}

const ColumnSettingsModal = (props: Props): JSX.Element => {
	const { isVisible, close, columns, onToggle } = props;

	return (
		<Dialog open={isVisible} onOpenChange={(open) => { if (!open) close(); }}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>Table Columns</DialogTitle>
				</DialogHeader>
				<div className="flex flex-col gap-3 max-h-[400px] overflow-y-auto">
					{columns.map((col) => (
						<label
							key={col.id}
							className="flex items-center cursor-pointer p-2.5 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
						>
							<input
								type="checkbox"
								checked={col.isVisible}
								onChange={() => onToggle(col.id)}
								className="mr-4 w-4 h-4 cursor-pointer accent-primary"
							/>
							<span className="text-foreground text-sm">
								{col.label}
							</span>
						</label>
					))}
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default ColumnSettingsModal;
